import { useEffect, useState } from "react";
import { getAllOrders } from "../utils/functionFirebase";
import Loader from "../components/Loader";
import { Button, Table, Container } from "react-bootstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, updateDoc, getDocs, collection } from "firebase/firestore";
import { data } from "../firebase/firebese";
import { toast } from 'react-toastify';

export default function AdminDashboard() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDay, setSelectedDay] = useState(null);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      console.log("Current user:", user);
      if (!user) {
        navigate("/auth");
        return;
      }
      const userDoc = await getDoc(doc(data, "authentact", user.uid));
      console.log("userDoc.exists():", userDoc.exists());
      console.log("userDoc.data():", userDoc.data());
      if (!userDoc.exists() || userDoc.data().isAdmain !== true) {
        toast.error("ليس لديك صلاحية للوصول لهذه الصفحة!");
        navigate("/");
        return;
      }
      setChecking(false);
    });
    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    getAllOrders().then(data => {
      setOrders(data);
      setLoading(false);
    });
  }, []);

  const totalSales = orders.reduce((sum, o) => sum + (o.total || 0), 0);

  function exportToExcel() {
    if (!orders.length) return;
    const mapped = orders.map(order => ({
      "رقم الهاتف": order.phone || "-",
      "المجموع": order.total,
      "رقم الطاولة": order.tableNumber,
      "التاريخ": order.date ? new Date(order.date).toLocaleDateString("ar-EG") : "-",
      "عدد المنتجات": order.items?.length,
    }));
    const ws = XLSX.utils.json_to_sheet(mapped);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "الطلبات");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "orders.xlsx");
  }

  // تجميع الطلبات حسب اليوم
  function groupOrdersByDay(orders) {
    const grouped = {};
    orders.forEach(order => {
      if (!order.date) return;
      const day = new Date(order.date).toLocaleDateString("ar-EG");
      if (!grouped[day]) grouped[day] = [];
      grouped[day].push(order);
    });
    return grouped;
  }

  const groupedOrders = groupOrdersByDay(orders);
  const days = Object.keys(groupedOrders);

  // حذف جميع الطلبات (من جميع المستخدمين)
  async function handleDeleteAllOrders() {
    if (!window.confirm("هل أنت متأكد أنك تريد حذف جميع الطلبات؟")) return;
    const usersSnap = await getDocs(collection(data, "authentact"));
    for (const userDoc of usersSnap.docs) {
      const userData = userDoc.data();
      if (Array.isArray(userData.actions)) {
        const filtered = userData.actions.filter(action => action.type !== "order");
        await updateDoc(doc(data, "authentact", userDoc.id), { actions: filtered });
      }
    }
    setOrders([]);
    toast.success("تم حذف جميع الطلبات بنجاح.");
  }

  // حذف جميع الطلبات ليوم معين
  async function handleDeleteDayOrders(day) {
    if (!window.confirm(`هل أنت متأكد أنك تريد حذف جميع طلبات يوم ${day}؟`)) return;
    const usersSnap = await getDocs(collection(data, "authentact"));
    for (const userDoc of usersSnap.docs) {
      const userData = userDoc.data();
      if (Array.isArray(userData.actions)) {
        const filtered = userData.actions.filter(action => {
          if (action.type !== "order") return true;
          if (!action.date) return true;
          const actionDay = new Date(action.date).toLocaleDateString("ar-EG");
          return actionDay !== day;
        });
        await updateDoc(doc(data, "authentact", userDoc.id), { actions: filtered });
      }
    }
    // تحديث الطلبات في الواجهة
    setOrders(orders.filter(order => {
      if (!order.date) return true;
      const actionDay = new Date(order.date).toLocaleDateString("ar-EG");
      return actionDay !== day;
    }));
    toast.success(`تم حذف جميع طلبات يوم ${day} بنجاح.`);
  }

  if (checking) return <Loader />; // عرض Loader أثناء التحقق من الصلاحيات
  if (loading) return <Loader />;

  return (
    <Container className="py-4">
      <h3 className="mb-4 text-center">لوحة تحكم الأدمن</h3>
      <div className="mb-3">
        <Button variant="danger" className="mx-2" onClick={handleDeleteAllOrders}>حذف جميع الطلبات</Button>
        <Button className="mx-3" onClick={exportToExcel}>تصدير الطلبات إلى Excel</Button>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>اليوم</th>
            <th>عدد الطلبات</th>
            <th>إجمالي المبيعات</th>
            <th>تفاصيل</th>
            <th>حذف اليوم</th>
          </tr>
        </thead>
        <tbody>
          {days.map(day => {
            const dayOrders = groupedOrders[day];
            const dayTotal = dayOrders.reduce((sum, o) => sum + (o.total || 0), 0);
            return (
              <tr key={day}>
                <td>{day}</td>
                <td>{dayOrders.length}</td>
                <td>{dayTotal} د.أ</td>
                <td>
                  <Button size="sm" onClick={() => setSelectedDay(day)}>
                    عرض الطلبات
                  </Button>
                </td>
                <td>
                  <Button size="sm" variant="danger" onClick={() => handleDeleteDayOrders(day)}>
                    حذف اليوم
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      {/* تفاصيل الطلبات لليوم المحدد */}
      {selectedDay && (
        <>
          <h5 className="mt-4">طلبات يوم {selectedDay}</h5>
          <Button variant="secondary" size="sm" onClick={() => setSelectedDay(null)}>إغلاق</Button>
          <Table striped bordered hover className="mt-2">
            <thead>
              <tr>
                <th>#</th>
                <th>رقم الهاتف</th>
                <th>المجموع</th>
                <th>رقم الطاولة</th>
                <th>التاريخ</th>
                <th>عدد المنتجات</th>
              </tr>
            </thead>
            <tbody>
              {groupedOrders[selectedDay].map((order, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{order.phone || "-"}</td>
                  <td>{order.total}</td>
                  <td>{order.tableNumber}</td>
                  <td>{order.date ? new Date(order.date).toLocaleString("ar-EG") : "-"}</td>
                  <td>{order.items?.length}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </Container>
  );
} 